import React, { useState, useEffect } from "react";
import { withTranslation } from "react-i18next";
import PropTypes from "prop-types";
import axios from "axios";
import { Image, TextInput, Dropdown } from "hesus-ui-kit";
import Header from "../../../Header/Header";
import MultilineDocumentUploadWithType from "@components/DocumentUpload/MultilineDocumentUploadWithType";
import {
  labelStyles,
  inputStyles,
  labelStylesError,
  inputStylesError,
  noLabelStyles,
  dropdownStyles,
  dropdownStylesError,
  inputStylesGreenBorder,
  inputStylesBlueBorder,
  inputStylesGreyBorder,
  dropdownStylesBlueBorder,
  dropdownStylesGreyBorder,
  dropdownStylesGreenBorder,
} from "@utils/extra-style";
import {
  RowHeader,
  GridRow,
  GridSubItem,
  GridItem,
  CounterNotification,
} from "../../AddEditHaulierSummary.styled";
import enableIcon from "@icons/ic-enable.svg";
import disableIcon from "@icons/ic-disable.svg";
import greyDocumentIcon from "@icons/add-grey-document.svg";
import greenDocumentIcon from "@icons/add-green-document.svg";

const GlobalSummary = (props) => {
  const {
    t,
    summaries,
    onChange,
    transportOnly,
    documentShow,
    setDocumentShow,
    isEditMode,
    onDocumentUpload,
    onDeleteDocument,
    documentTypeOptions,
  } = props;
  const centreUnit = [
    {
      label: t("TON"),
      value: "TON",
    },
    {
      label: t("M3"),
      value: "M3",
    },
    {
      label: t("LOAD"),
      value: "LOAD",
    },
  ];
  const getColumnInfo = () => {
    let column = "40% 15% 10% 25% 10%";
    if (!transportOnly) {
      column = "25% 10% 10% 23% 22% 10%";
    }
    return column;
  };

  const showDocumentSection = (id) => {
    if (documentShow.indexOf(id) !== -1) {
      const index = documentShow.indexOf(id);
      if (index >= 0) {
        documentShow.splice(index, 1);
      }
    } else {
      documentShow.push(id);
    }
    setDocumentShow([...documentShow]);
  };

  const uploadImage = () => {};

  return (
    <>
      <RowHeader>
        <GridRow
          column={getColumnInfo}
          marginTop="0px"
          marginBottom="0px"
          gridGap="0rem"
        >
          <Header
            title={!transportOnly ? "SUMMARY_FORM_CENTRE" : ""}
            borderRadius="left"
            align="left"
            color="#008395"
          />

          <Header title="SUMMARY_FORM_PLANNED" align="center" color="#008395" />
          <Header title="SUMMARY_FORM_DONE" align="center" color="#008395" />
          {transportOnly && (
            <Header
              title="SUMMARY_FORM_HAULAGE"
              align="center"
              borderRadius="right"
              color="#008395"
            />
          )}
          {!transportOnly && (
            <>
              <Header
                title="SUMMARY_FORM_HAULAGE"
                align="center"
                color="#008395"
              />
              <Header
                title="SUMMARY_FORM_CENTER"
                align="center"
                color="#008395"
              />
            </>
          )}
          <Header
            title=""
            align="center"
            borderRadius="right"
            color="#008395"
          />
        </GridRow>
      </RowHeader>
      {summaries.map((summaryArray, index) => {
        return (
          <React.Fragment key={"global_summary_" + index}>
            {summaryArray.length === 0 && (
              <GridRow
                column="1fr"
                key={"haulier-summary-planningline-no-data" + summaryIndex}
              >
                <GridSubItem
                  fontStyle="normal"
                  fontSize="16px"
                  color="#474747"
                  textAlign="center"
                >
                  {t("NO_DATA")}
                </GridSubItem>
              </GridRow>
            )}
            {summaryArray?.items?.map((summary, summaryIndex) => {
              return (
                <React.Fragment
                  key={"haulier-summary-planningline-" + summaryIndex}
                >
                  <GridRow
                    column={getColumnInfo}
                    marginBottom="0px"
                    gridGap="0rem"
                    marginTop="0px"
                    borderBottom="2px solid rgba(10, 73, 134, 0.3)"
                  >
                    <GridItem
                      borderLeft="2px solid rgba(10, 73, 134, 0.3)"
                      borderRight="2px solid rgba(10, 73, 134, 0.3)"
                      alignContent="center"
                    >
                      <GridSubItem
                        fontWeight="700"
                        fontSize="16px"
                        textAlign="left"
                        color="#0a4986"
                      >
                        {transportOnly && summary.company.value}
                        {!transportOnly &&
                          "[" +
                            summary.supplierName.value +
                            "]" +
                            " " +
                            summary.centreName.value}
                      </GridSubItem>
                    </GridItem>
                    <GridItem
                      borderRight="2px solid rgba(10, 73, 134, 0.3)"
                      alignContent="center"
                    >
                      <GridSubItem
                        fontWeight="400"
                        fontSize="16px"
                        textAlign="center"
                        color="#0a4986"
                      >
                        {summary.plannedQuantity.value +
                          " " +
                          t(summary.plannedUnit.value)}
                      </GridSubItem>
                    </GridItem>
                    <GridItem
                      borderRight="2px solid rgba(10, 73, 134, 0.3)"
                      alignContent="center"
                    >
                      <GridSubItem
                        fontWeight="700"
                        fontSize="16px"
                        textAlign="center"
                        color="#0a4986"
                      >
                        {!summary?.isSummaryInvoiced.value && (
                          <Image
                            src={
                              summary?.isDone.value ? enableIcon : disableIcon
                            }
                            alt="isDone"
                            styles={{ width: "auto", marginBottom: "5px" }}
                            onClick={(e) => {
                              onChange(
                                !summary?.isDone.value,
                                index,
                                summaryIndex,
                                "isDone"
                              );
                            }}
                          />
                        )}
                      </GridSubItem>
                    </GridItem>
                    <GridItem
                      borderRight="2px solid rgba(10, 73, 134, 0.3)"
                      alignContent="center"
                    >
                      <GridSubItem
                        fontWeight="700"
                        fontSize="16px"
                        textAlign="center"
                        color="#0a4986"
                      >
                        {!!summary?.isSummaryInvoiced.value && (
                          <GridRow column="1fr">
                            {summary.haulageQuantity.value +
                              " " +
                              t(summary.haulageUnit.value)}
                          </GridRow>
                        )}
                        {!summary?.isSummaryInvoiced.value && (
                          <GridRow column="1fr 1fr">
                            <TextInput
                              type="text"
                              name={summary.haulageQuantity.name}
                              id={summary.haulageQuantity.name}
                              isFloat
                              placeholder={t("QUANTITY")}
                              value={String(summary.haulageQuantity.value)}
                              required={false}
                              errorStyles={{ "font-style": "italic" }}
                              onChange={(e) => {
                                onChange(
                                  e,
                                  index,
                                  summaryIndex,
                                  "haulageQuantity"
                                );
                              }}
                              labelStyles={
                                summary.haulageQuantity.error !== ""
                                  ? labelStylesError
                                  : labelStyles
                              }
                              inputStyles={
                                summary.haulageQuantity.error !== ""
                                  ? inputStylesError
                                  : summary.isReadyForInvoicing.value
                                  ? inputStylesGreenBorder
                                  : !summary.isDone.value
                                  ? inputStylesGreyBorder
                                  : inputStylesBlueBorder
                              }
                              error={t(summary.haulageQuantity.error)}
                              disabled={
                                !summary.isDone.value ||
                                summary.isReadyForInvoicing.value
                              }
                            />
                            <Dropdown
                              name={summary.haulageUnit.name}
                              id={summary.haulageUnit.name}
                              value={String(summary.haulageUnit.value)}
                              defaultOption={t("UNIT")}
                              options={[
                                {
                                  label: t(summary.haulageUnit.value),
                                  value: summary.haulageUnit.value,
                                },
                              ]}
                              required={false}
                              onChange={(e) => {
                                onChange(e, index, summaryIndex, "haulageUnit");
                              }}
                              labelStyles={noLabelStyles}
                              inputStyles={
                                summary.haulageUnit.error !== ""
                                  ? dropdownStylesError
                                  : summary.isReadyForInvoicing.value
                                  ? dropdownStylesGreenBorder
                                  : !summary.isDone.value
                                  ? dropdownStylesGreyBorder
                                  : dropdownStylesBlueBorder
                              }
                              error={t(summary.haulageUnit.error)}
                              disabled
                            />
                          </GridRow>
                        )}
                      </GridSubItem>
                    </GridItem>
                    {!transportOnly && (
                      <GridItem
                        borderRight="2px solid rgba(10, 73, 134, 0.3)"
                        alignContent="center"
                      >
                        <GridSubItem
                          fontWeight="700"
                          fontSize="16px"
                          textAlign="center"
                          color="#0a4986"
                        >
                          {!!summary?.isSummaryInvoiced.value && (
                            <GridRow column="1fr">
                              {summary.centreQuantity.value +
                                " " +
                                t(summary.centreUnit.value)}
                            </GridRow>
                          )}
                          {!summary?.isSummaryInvoiced.value && (
                            <GridRow column="1fr 1fr">
                              <TextInput
                                type="text"
                                name={summary.centreQuantity.name}
                                id={summary.centreQuantity.name}
                                isFloat
                                placeholder={t("QUANTITY")}
                                value={String(summary.centreQuantity.value)}
                                required={false}
                                errorStyles={{ "font-style": "italic" }}
                                onChange={(e) => {
                                  onChange(
                                    e,
                                    index,
                                    summaryIndex,
                                    "centreQuantity"
                                  );
                                }}
                                labelStyles={
                                  summary.centreQuantity.error !== ""
                                    ? labelStylesError
                                    : labelStyles
                                }
                                inputStyles={
                                  summary.centreQuantity.error !== ""
                                    ? inputStylesError
                                    : summary.isReadyForInvoicing.value
                                    ? inputStylesGreenBorder
                                    : !summary.isDone.value
                                    ? inputStylesGreyBorder
                                    : inputStylesBlueBorder
                                }
                                error={t(summary.centreQuantity.error)}
                                disabled={
                                  !summary.isDone.value ||
                                  summary.isReadyForInvoicing.value
                                }
                              />
                              <Dropdown
                                name={summary.centreUnit.name}
                                id={summary.centreUnit.name}
                                value={String(summary.centreUnit.value)}
                                defaultOption={t("UNIT")}
                                options={centreUnit}
                                required={false}
                                onChange={(e) => {
                                  onChange(
                                    e,
                                    index,
                                    summaryIndex,
                                    "centreUnit"
                                  );
                                }}
                                labelStyles={noLabelStyles}
                                inputStyles={
                                  summary.centreUnit.error !== ""
                                    ? dropdownStylesError
                                    : summary.isReadyForInvoicing.value
                                    ? dropdownStylesGreenBorder
                                    : !summary.isDone.value
                                    ? dropdownStylesGreyBorder
                                    : dropdownStylesBlueBorder
                                }
                                error={t(summary.centreUnit.error)}
                                disabled={
                                  !summary.isDone.value ||
                                  summary.isReadyForInvoicing.value
                                }
                              />
                            </GridRow>
                          )}
                        </GridSubItem>
                      </GridItem>
                    )}
                    <GridItem
                      borderRight="2px solid rgba(10, 73, 134, 0.3)"
                      alignContent="center"
                    >
                      <GridSubItem
                        fontWeight="700"
                        fontSize="16px"
                        textAlign="center"
                        color="#0a4986"
                        style={{ position: "relative" }}
                      >
                        <Image
                          src={
                            summary.isDone.value
                              ? greenDocumentIcon
                              : greyDocumentIcon
                          }
                          title={t("SUMMARIES_DOCUMENTS_TOOLTIP")}
                          onClick={() => showDocumentSection(summary.id.value)}
                          alt={t("SUMMARIES_DOCUMENTS_TOOLTIP")}
                          className="haulier-global-summary__image-icon"
                          styles={{ width: "30px", cursor: "pointer" }}
                        />
                        {!!summary.isDone.value && (
                          <CounterNotification>
                            {summary.documentCount.value}
                          </CounterNotification>
                        )}
                      </GridSubItem>
                    </GridItem>
                  </GridRow>
                  {documentShow.indexOf(summary.id.value) !== -1 && (
                    <GridRow
                      marginBottom="0px"
                      gridGap="0rem"
                      marginTop="0px"
                      borderBottom="2px solid rgba(10, 73, 134, 0.3)"
                      column="1fr"
                    >
                      <GridItem
                        borderRight="2px solid rgba(10, 73, 134, 0.3)"
                        borderLeft="2px solid rgba(10, 73, 134, 0.3)"
                        alignContent="center"
                        backgroundColor="#ededed"
                      >
                        <MultilineDocumentUploadWithType
                          isEditMode={isEditMode}
                          onDocumentUpload={onDocumentUpload}
                          existingDocuments={summary.existingDocuments.value}
                          newDocument={summary.documents.value}
                          documentTypes={summary.documents.documentTypes}
                          documentTypeOptions={documentTypeOptions}
                          mainIndex={index}
                          summaryIndex={summaryIndex}
                          onDeleteDocument={onDeleteDocument}
                        />
                      </GridItem>
                    </GridRow>
                  )}
                </React.Fragment>
              );
            })}
          </React.Fragment>
        );
      })}
    </>
  );
};

GlobalSummary.propTypes = {
  t: PropTypes.func.isRequired,
};

GlobalSummary.defaultProps = {};

export default withTranslation()(GlobalSummary);
